import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Typography } from "antd";
const { Text } = Typography;

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-darkMode-background">
      <div className="text-center p-8">
        <h1 className="text-6xl font-bold mb-4 text-darkMode-text">404</h1>
        <p className="text-2xl text-darkMode-subText mb-8">
          Oops! Page not found
        </p>
        <Link to="/Dashboard">
          <button
            className="rounded-xl py-3 px-8"
            style={{
              backgroundColor: "#50CD89",
              borderColor: "#50CD89",
            }}
          >
            <span className="text-darkMode-layer3 text-xl font-semibold">
              Return to Dashboard
            </span>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
